export const BUBBLE_CHART_I18N_PREFIX = "features.shared_components.chart.bubble_chart";

export const BUBBLE_CHART_I18N_KEYS = {
  sub_topic:             "sub_topic",
  sub_topic_description: "sub_topic_description",
  comments_percentage:   "comments_percentage",
  emotions_percentage:   "emotions_percentage",
  top_5_keywords:        "top_5_keywords",
  anger:                 "anger",
  fear:                  "fear",
  joy:                   "joy",
  sadness:               "sadness",
  no_specific_emotion:   "no_specific_emotion",
  csv:                   "csv"
};


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/constants/i18n/BubbleCharti18nConstants.js